import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import arrow from "../../images/RightArrowTwo.png";
import DashboardImag from "../../images/Banner.png";
import "./style.css";
import ModalHeaderText from "../../common/ModalHeaders/ModalHeaderText";
import { Button, Form, Modal, notification } from "antd";
import { connect } from "react-redux";
import useSession from "../CustomLogout/useSession";
import { getDashboardDetailsDetails } from "../../redux/DashBoard/action";
import YouTube from "react-youtube";
import Self_User_Registration from "../../images/Self_User_Registration.png";
import Lead_Dashboard from "../../images/Lead_Dashboard.png";
import Bulk_Lead_Upload from "../../images/Bulk_Lead_Upload.png";
import API_Integration from "../../images/API_Integration.png";
import Document_Upload from "../../images/Document_Upload.png";
import Lead_Duplication from "../../images/Lead_Duplication.png";
import { imageTitles } from "../../utils/constants";
const DashBoardComponent = (props) => {
  const handleSessionExpired = useSession();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dashataDashBoard, setDataDashBoard] = useState("");
  const [leadActivation, setLeadActivation] = useState(false);
  const [loading, setLoading] = useState(true);
  const [partnerFirmStatus, setPartnerFirmStatus] = useState("");
  const [form] = Form.useForm();
  const [player, setPlayer] = useState(null);

  const handleOpen = () => {
    setIsModalVisible(true);
  };

  const formatDate = (approveOn) => {
    // Define formatting options for the date
    const options = {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: false,
    };

    // Create a new Date object from the input date and format it as a localized string
    return new Date(approveOn).toLocaleDateString(undefined, options);
  };

  useEffect(() => {
    setDataDashBoard("");
    props
      .getDashboardDetailsDetails({
        access_token: props?.accessToken,
        partnerFirmId: props?.firmId,
      })
      .then((res) => {
        if (res?.status === 200) {
          setDataDashBoard(res?.data?.dto);
          setLeadActivation(res?.data?.dto?.leadActivationFlag);
          setPartnerFirmStatus(res?.data?.dto?.partnerFirmStatus);
          setLoading(false);
        }
        if (res?.data?.error || res?.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res?.message;
          setLoading(false);

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            setLoading(false);
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((err) => {
        console.log("Error details", err);
      });
  }, []);

  function getYoutubeVideoId(url) {
    if (!url) {
      return null;
    }

    // Extracts the video ID from a YouTube URL
    const videoIdRegex =
      /(?:youtube(?:-nocookie)?\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/;
    const match = url.match(videoIdRegex);
    return match ? match[1] : null;
  }

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleAfterClose = () => {
    if (player) {
      player.pauseVideo();
    }
  };
  const handlePlayerReady = (event) => {
    setPlayer(event.target);
    event.target.playVideo(); // Autoplay the video when the player is ready
  };

  const imageUrls = [
    Self_User_Registration,
    Lead_Dashboard,
    Bulk_Lead_Upload,
    API_Integration,
    Document_Upload,
    Lead_Duplication,
  ];

  return (
    !loading && (
      <div>
        <Modal
          open={isModalVisible}
          closable={false}
          className="modal-container"
          centered
          footer={null}
          onCancel={handleCancel}
          afterClose={handleAfterClose}
        >
          <Form
            autoComplete="off"
            name="logout"
            className="change-password"
            form={form}
          >
            <Row>
              <Col lg={12} xs={12} md={12} sm={12}>
                <Col md={12} className="headre-login">
                  <ModalHeaderText LoginHeading="Watch Demo" />
                </Col>
              </Col>
            </Row>
            <Row>
              <Col lg={12} xs={12} md={12} sm={12} className="video0please">
                <YouTube
                  videoId={getYoutubeVideoId(dashataDashBoard?.url)}
                  opts={{
                    height: "315",
                    width: "100%",
                    playerVars: {
                      autoplay: 1,
                    },
                  }}
                  onReady={handlePlayerReady}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12} className="d-flex justify-content-end mt-4">
                <Button htmlType="button" type="default" onClick={handleCancel}>
                  CANCEL
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal>

        <div className="content-sec-dashboard">
          <div className="content-card">
            <Row>
              <Col lg={12} xs={12} md={12} sm={12} className="main-sec-dash">
                {leadActivation && partnerFirmStatus !== "NEW PARTNER" && (
                  <Col md={8} className="welcome-note">
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      className="main-sec-dash"
                    >
                      <Col md={6}>
                        <div className="left-side-content">
                          <h5>Welcome to </h5>
                          <h4>Avanse Partner Portal</h4>
                          <p>
                            <span>
                              Adding the leads, managing them and tracking their
                              status will now be a cakewalk!
                            </span>{" "}
                          </p>
                          <span className="btn-watch" onClick={handleOpen}>
                            <h3>Watch Demo Video </h3>
                            <img src={arrow} alt="" />
                          </span>
                        </div>
                      </Col>
                      <Col md={6} className="img-side-content">
                        <div className="right-side-content">
                          <img draggable={false} src={DashboardImag} alt="" />
                        </div>
                      </Col>
                    </Col>
                  </Col>
                )}

                <Col
                  md={4}
                  style={
                    leadActivation
                      ? {}
                      : {
                          marginTop: "20px",
                        }
                  }
                  className={"ESign-note"}
                >
                  <div className="inner-content-sec">
                    <div className="test">
                      <h5>{dashataDashBoard?.partnerDisplayCode}</h5>
                      <h4>{dashataDashBoard?.partnerFirmName} </h4>
                    </div>
                    <div className="count-sec">
                      <Col
                        lg={12}
                        xs={12}
                        md={12}
                        sm={12}
                        className="main-sec-dash mob"
                      >
                        <Col md={6}>
                          <h5>Branch Count </h5>
                        </Col>
                        <Col md={6}>
                          <h5 className="count-number-tes">
                            {dashataDashBoard?.partnerBranchCount
                              ? dashataDashBoard?.partnerBranchCount
                              : 0}
                          </h5>
                        </Col>
                      </Col>
                      <Col
                        lg={12}
                        xs={12}
                        md={12}
                        sm={12}
                        className="main-sec-dash mob"
                      >
                        <Col md={6}>
                          <h5>Team Count </h5>
                        </Col>
                        <Col md={6}>
                          <h5 className="count-number-tes">
                            {dashataDashBoard?.partnerTeamCount
                              ? dashataDashBoard?.partnerTeamCount
                              : 0}
                          </h5>
                        </Col>
                      </Col>
                      <div
                        className={
                          dashataDashBoard?.partnerFirmStatus === "APPROVED"
                            ? "status-green"
                            : "status" &&
                              dashataDashBoard?.partnerFirmStatus === "REJECTED"
                            ? "status-red"
                            : "status"
                        }
                      >
                        <span>{dashataDashBoard?.partnerFirmStatus}</span>
                      </div>
                    </div>

                    <div className="last-log">
                      <h5>
                        Last Login: {""}
                        {dashataDashBoard?.lastLogin
                          ? formatDate(dashataDashBoard?.lastLogin)
                          : "----"}
                      </h5>
                    </div>
                  </div>
                </Col>
              </Col>
            </Row>

            <header className="new-feature-header">
              Just Released: New Tools to Supercharge Your Productivity!
            </header>
            <section className="new-feature-container">
              {imageUrls?.map((url, index) => (
                <div className="feature-item" key={index}>
                  <img
                    src={url}
                    alt={`Image ${index + 1}`}
                    className="custom-colored-image"
                  />
                  <div className="feature-title">{imageTitles[index]}</div>
                </div>
              ))}
            </section>
          </div>
        </div>
      </div>
    )
  );
};

const mapStateToProps = (state) => {
  return {
    state: state.auth,

    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId,
    LogoutFlag: state.Logout,
    accessToken: state?.auth?.idToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDashboardDetailsDetails: (user) =>
      dispatch(getDashboardDetailsDetails(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DashBoardComponent);
